<div class="page-design document-grid-list">
  <!-- <div class="strip_head toggleleft my-2 d-flex justify-content-between"></div> -->
  <!-- <div class="clearfix"></div> -->
  <div class="row">
    <div class="col-12">
      <p-card styleClass="rbac-card gridview w-100">
        <div *ngIf="archivedTabEnabled" class="document-tab-switch mb-3" role="tablist" aria-label="Document sections">
          <button
            type="button"
            class="document-tab-btn"
            role="tab"
            [class.active]="isDocumentTabActive('upload')"
            [attr.aria-selected]="isDocumentTabActive('upload')"
            [attr.tabindex]="isDocumentTabActive('upload') ? 0 : -1"
            (click)="setActiveDocumentTab('upload')">
            Active Documents
          </button>
          <button
            type="button"
            class="document-tab-btn"
            role="tab"
            [class.active]="isDocumentTabActive('archived')"
            [attr.aria-selected]="isDocumentTabActive('archived')"
            [attr.tabindex]="isDocumentTabActive('archived') ? 0 : -1"
            (click)="setActiveDocumentTab('archived')">
            Archived Documents
          </button>
        </div>

        <div class="document-grid-header d-flex w-100 justify-content-end align-items-center mb-10">
          <button *ngIf="isDocumentTabActive('upload') && !readOnlyMode" type="button" class="btn btn-primary grid rounded upload-btn" aria-label="Upload" pRipple icon="pi pi-plus"
            [pTooltip]="buttonLabel ? buttonLabel : 'Upload'" tooltipPosition="bottom"
            (click)="showUploadModal(uploadModel)" [disabled]="!canUploadDocuments()"><img src="../../../../assets/images/neveda-images/upload.svg" alt=""> Upload</button>
        </div>
        <div *ngIf="!canUploadDocuments() && isDocumentTabActive('upload') && !readOnlyMode" class="text-danger small mb-2">
          {{ dnqUploadMessage }}
        </div>
          <ng-container *ngIf="isDocumentTabActive('upload'); else archivedDocumentsGrid">
        <app-registration-template
          (legalChangeEvent)="getLegalChangeEventValue($event)"
          (activeDutyChangeEvent)="onActiveDutyChange($event)"
          (spouseActiveDutyChangeEvent)="onSpouseActiveDutyChange($event)"
          (veteranDefinitionChangeEvent)="onVeteranDefinitionChange($event)"
          (spouseVeteranChangeEvent)="onSpouseVeteranChange($event)"></app-registration-template>
        <div class="documentHistoryTable">
        <dx-data-grid #dataGrid [dataSource]="uploadDocumentHistory" [showBorders]="true" [rowAlternationEnabled]="false"
          [columnAutoWidth]="true" [wordWrapEnabled]="true" (onSelectionChanged)="onSelectionChanged($event)"
          (onContentReady)="addTooltipToSelectAll()" (onRowPrepared)="onRowPrepared($event)">
          <!-- <dxo-search-panel [visible]="true" [highlightCaseSensitive]="false" [width]="240" [placeholder]="'Search...'"
            [searchVisibleColumnsOnly]="false">
          </dxo-search-panel>
          <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
          <dxo-header-filter [visible]="true"></dxo-header-filter> -->
          <!-- <dxo-selection [mode]="'multiple'" [showCheckBoxesMode]="'always'"></dxo-selection> -->
          <!-- <dxo-paging [pageSize]="4"></dxo-paging>
          <dxo-pager [visible]="true" [allowedPageSizes]="[4, 8,12,16]" [showPageSizeSelector]="true"
            [showNavigationButtons]="true" [showInfo]="true" [displayMode]="displayMode"></dxo-pager> -->
          <dxo-scrolling mode="standard" showScrollbar="never"></dxo-scrolling>
          <dxi-column dataField="cd_document_category" caption="Category" [dataType]="'string'" [allowFiltering]="true" cellTemplate="categoryEditor"></dxi-column>
          <dxi-column dataField="cd_document_type" caption="Type" [dataType]="'string'" [allowFiltering]="true" cellTemplate="typeEditor"></dxi-column>
          <dxi-column dataField="file_name" caption="Filename" [dataType]="'string'" [allowFiltering]="true" cellTemplate="fileNameTemplate"></dxi-column>
          <dxi-column dataField="status" caption="Document Status" [dataType]="'string'" [allowFiltering]="true" cellTemplate="statusTemplate"></dxi-column>
          <dxi-column dataField="created" caption="Uploaded By" [dataType]="'string'" [allowFiltering]="true"></dxi-column>
          <dxi-column dataField="createdat" caption="Date Uploaded" [dataType]="'date'" [allowFiltering]="true"
            format="MM/dd/yyyy"></dxi-column>
          <dxi-column caption="Actions" [width]="200" [allowSorting]="false" [allowFiltering]="false" cellTemplate="actionsTemplate" cssClass="action-column"></dxi-column>
          
          <div *dxTemplate="let data of 'categoryEditor'">
            <div class="dropdown-clear-wrapper">
              <span [ngClass]="{'text-muted': !getCategoryDisplayForRow(data.data)}">
                {{ getCategoryDisplayForRow(data.data) || 'Not provided' }}
              </span>
            </div>
          </div>
          
          <div *dxTemplate="let data of 'typeEditor'">
            <div class="dropdown-clear-wrapper" style="width: 100%; min-width: 250px;">
              <ng-container *ngIf="!readOnlyMode && !isRowTypeLocked(data.data) && getDocumentTypesForCategory(data.data.cd_document_category)?.length; else typeDisplay">
                <div class="select-placeholder-wrapper">
                  <select class="form-control accessible-select"
                    [ngModel]="data.data.cd_document_type"
                    (ngModelChange)="onRowTypeChange(data.data, $event)"
                    style="width: 100%; min-width: 200px;"
                    [attr.aria-label]="'Document type, ' + (getDocumentTypeDisplayValue(data.data.cd_document_type) || 'none selected')"
                    [class.has-value]="data.data.cd_document_type">
                    <option *ngFor="let d of getDocumentTypesForCategory(data.data.cd_document_category)" [value]="d.key">{{ d.value }}</option>
                  </select>
                  <span class="select-placeholder" *ngIf="!data.data.cd_document_type" aria-hidden="true">Select Type</span>
                  <span class="sr-only" aria-live="polite" aria-atomic="true">{{ data.data.cd_document_type ? 'Selected: ' + getDocumentTypeDisplayValue(data.data.cd_document_type) : '' }}</span>
                </div>
              </ng-container>
              <ng-template #typeDisplay>
                <span class="text-muted">{{ getDocumentTypeDisplayForRow(data.data) || 'Not provided' }}</span>
              </ng-template>
            </div>
          </div>

          <div *dxTemplate="let data of 'statusTemplate'">
            <div class="status-cell">
              <span class="status-text">{{ data.data?.status }}</span>
              <button
                *ngIf="isDeficientStatus(data.data)"
                type="button"
                class="deficiency-note-btn"
                pTooltip="View deficiency notes"
                tooltipPosition="bottom"
                (click)="openDeficiencyNotesModal(data.data, deficiencyNotesModel)">
                <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                <span class="sr-only">View deficiency notes</span>
              </button>
            </div>
          </div>

          <div *dxTemplate="let data of 'fileNameTemplate'">
            <span class="file-name-cell" [attr.title]="data.data?.file_name || ''">
              {{ data.data?.file_name || '-' }}
            </span>
          </div>

          <div *dxTemplate="let data of 'actionsTemplate'">
            <!-- Show file actions only when a file exists on the row -->
            <div class="action-icons">
              <button *ngIf="data.data && data.data.file_name && (isShowView === true)" class="fa fa-eye view-btn" pTooltip="View" tooltipPosition="top" (click)="onView(data.data)"  tooltipStyleClass="pcustom-tooltip">
                <span class="sr-only">View</span>
              </button>
              <button *ngIf="data.data && data.data.file_name && (isShowDownload === true)" class="fa fa-download download-btn" pTooltip="Download" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onDownload(data.data)">
                <span class="sr-only">Download</span>
              </button>
              <button *ngIf="data.data && data.data.file_name && (isShowDelete === true) && canDeleteDocument(data.data) && !readOnlyMode" class="fa fa-trash delete-btn" pTooltip="Delete" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onDelete(data.data, deleteModel)">
                <span class="sr-only">Delete</span>
              </button>
              <button *ngIf="data.data && data.data.file_name && data.data.status !== 'Validated' && data.data.status !== 'Deficient' && (isShowMarkAsValid === true) && !readOnlyMode" class="fa fa-check-circle valid-btn" pTooltip="Mark as Valid" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="openConfirmValidModal(data.data, confirmValidModel)">
                <span class="sr-only">Mark as Valid</span>
              </button>
              <button *ngIf="data.data && data.data.file_name && data.data.status !== 'Validated' && data.data.status !== 'Deficient' && (isShowMarkAsDificient === true) && !readOnlyMode" class="fa fa-exclamation-circle deficient-btn" pTooltip="Mark as Deficient" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="openDeficientModal(data.data, deficientModel)">
                <span class="sr-only">Mark as Deficient</span>
              </button>
              <button *ngIf="data.data && data.data.file_name && data.data.status === 'Deficient' && data.data.status !== 'Validated' && (isShowReplaceFile === true) && canUploadDocuments() && !readOnlyMode" class="fa fa-file-o replace-btn" pTooltip="Replace File" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="openReplaceModal(data.data, replaceModel)">
                <span class="sr-only">Replace File</span>
              </button>
              <!-- Upload button: only when no file and required dropdowns are selected -->
              <button
                *ngIf="data.data && !data.data.file_name  && (!getDocumentTypesForCategory(data.data.cd_document_category).length || data.data.cd_document_type) && canUploadDocuments() && !readOnlyMode"
                type="button"
                class="upload-row-btn"
                pTooltip="Upload File"
                tooltipPosition="bottom"
                (click)="openRowUpload(data.data, rowUploadModel)">
                <i class="fa fa-upload" aria-hidden="true"></i>
                <span>Upload</span>
              </button>
            </div>
          </div>
        </dx-data-grid>
      </div>
    </ng-container>

    <ng-template #archivedDocumentsGrid>
          <div class="documentHistoryTable archived-document-table">
            <dx-data-grid [dataSource]="archivedDocumentHistory" [showBorders]="true" [rowAlternationEnabled]="true"
              (onRowPrepared)="onRowPrepared($event)"
              [columnAutoWidth]="true" [wordWrapEnabled]="true">
              <dxo-scrolling mode="standard" showScrollbar="never"></dxo-scrolling>
              <dxi-column dataField="cd_document_category" caption="Category" [dataType]="'string'" [allowFiltering]="true"
                cellTemplate="archivedCategoryCell"></dxi-column>
              <dxi-column dataField="cd_document_type" caption="Type" [dataType]="'string'" [allowFiltering]="true"
                cellTemplate="archivedTypeCell"></dxi-column>
              <dxi-column dataField="file_name" caption="Filename" [dataType]="'string'" [allowFiltering]="true" cellTemplate="archivedFileNameTemplate"></dxi-column>
              <dxi-column dataField="status" caption="Document Status" [dataType]="'string'" [allowFiltering]="true" cellTemplate="archivedStatusTemplate"></dxi-column>
              <dxi-column dataField="created" caption="Uploaded By" [dataType]="'string'" [allowFiltering]="true"></dxi-column>
              <dxi-column dataField="createdat" caption="Date Uploaded" [dataType]="'date'" [allowFiltering]="true"
                format="MM/dd/yyyy"></dxi-column>
              <dxi-column caption="Actions" [width]="200" [allowSorting]="false" [allowFiltering]="false" cellTemplate="archivedActionsTemplate" cssClass="action-column"></dxi-column>

              <div *dxTemplate="let data of 'archivedCategoryCell'">
              <div class="dropdown-clear-wrapper">
                <span [ngClass]="{'text-muted': !getCategoryDisplayForRow(data.data)}">
                  {{ getCategoryDisplayForRow(data.data) || 'Not provided' }}
                </span>
              </div>
              </div>

              <div *dxTemplate="let data of 'archivedTypeCell'">
                <div class="dropdown-clear-wrapper" style="width: 100%; min-width: 250px;">
                  <ng-container *ngIf="!readOnlyMode && !isRowTypeLocked(data.data) && getDocumentTypesForCategory(data.data.cd_document_category)?.length; else archivedTypeDisplay">
                    <div class="select-placeholder-wrapper">
                      <select class="form-control accessible-select"
                        [ngModel]="data.data.cd_document_type"
                        (ngModelChange)="onRowTypeChange(data.data, $event)"
                        style="width: 100%; min-width: 200px;"
                        [attr.aria-label]="'Document type, ' + (getDocumentTypeDisplayValue(data.data.cd_document_type) || 'none selected')"
                        [class.has-value]="data.data.cd_document_type">
                        <option *ngFor="let d of getDocumentTypesForCategory(data.data.cd_document_category)" [value]="d.key">{{ d.value }}</option>
                      </select>
                      <span class="select-placeholder" *ngIf="!data.data.cd_document_type" aria-hidden="true">Select Type</span>
                      <span class="sr-only" aria-live="polite" aria-atomic="true">{{ data.data.cd_document_type ? 'Selected: ' + getDocumentTypeDisplayValue(data.data.cd_document_type) : '' }}</span>
                    </div>
                  </ng-container>
                  <ng-template #archivedTypeDisplay>
                    <span class="text-muted">{{ getDocumentTypeDisplayForRow(data.data) || 'Not provided' }}</span>
                  </ng-template>
                </div>
              </div>

              <div *dxTemplate="let data of 'archivedStatusTemplate'">
                <div class="status-cell">
                  <span class="status-text">{{ data.data?.status }}</span>
                  <button
                    *ngIf="isDeficientStatus(data.data)"
                    type="button"
                    class="deficiency-note-btn"
                    pTooltip="View deficiency notes"
                    tooltipPosition="bottom"
                    (click)="openDeficiencyNotesModal(data.data, deficiencyNotesModel)">
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                    <span class="sr-only">View deficiency notes</span>
                  </button>
                </div>
              </div>

              <div *dxTemplate="let data of 'archivedFileNameTemplate'">
                <span class="file-name-cell" [attr.title]="data.data?.file_name || ''">
                  {{ data.data?.file_name || '-' }}
                </span>
              </div>

              <div *dxTemplate="let data of 'archivedActionsTemplate'">
                <div class="action-icons">
                  <button *ngIf="data.data && data.data.file_name && (isShowView === true)" class="fa fa-eye" pTooltip="View" tooltipPosition="bottom" (click)="onView(data.data)">
                    <span class="sr-only">View</span>
                  </button>
                  <button *ngIf="data.data && data.data.file_name && (isShowDownload === true)" class="fa fa-download" pTooltip="Download" tooltipPosition="bottom" (click)="onDownload(data.data)">
                    <span class="sr-only">Download</span>
                  </button>
                </div>
              </div>
            </dx-data-grid>
          </div>
        </ng-template>
      </p-card>
    </div>
  </div>

  <!-- Deficiency notes modal -->
  <ng-template #deficiencyNotesModel let-modal>
    <div class="modal-shell duplicate-doc-modal">
      <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title mb-0">Deficiency Notes</h4>
        <button type="button" class="close" aria-label="Close" (click)="closePopup()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-modal-body p-3">
        <p class="mb-0">{{ deficiencyNotesView || 'No notes available.' }}</p>
      </div>
      <div class="form-modal-footer p-3">
        <div class="modal-actions d-flex justify-content-end">
          <button type="button" class="btn document-preview-cancel btn-md px-3 py-1" (click)="closePopup()">Close</button>
        </div>
      </div>
    </div>
  </ng-template>
  
  <!-- Deficient modal -->
  <ng-template #deficientModel let-modal>
    <div class="modal-shell duplicate-doc-modal deficient-modal">
      <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Confirm Deficiency</h4>
        <button type="button" class="close" aria-label="Close" (click)="closePopup()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-modal-body p-3">
        <p class="mb-3">
          This will mark the record as deficient, indicating it has been reviewed and requires correction or additional information.
        </p>
        <div class="mb-3">
          <label class="form-label">Deficiency Notes <span class="text-danger">*</span></label>
          <textarea class="form-control" rows="4" [(ngModel)]="deficiencyReason" name="deficiencyReason"
            [ngClass]="{ 'is-invalid': deficiencyError }" (ngModelChange)="deficiencyError = ''"></textarea>
          <div class="invalid-feedback d-block" *ngIf="deficiencyError">{{ deficiencyError }}</div>
        </div>
      </div>
      <div class="form-modal-footer p-3">
        <div class="modal-actions d-flex justify-content-center gap-2">
          <button class="btn btn-primary btn-md px-3 py-1" (click)="onSaveDeficiency()">Proceed</button>
          <button class="btn document-preview-cancel btn-md px-3 py-1" (click)="closePopup()">Cancel</button>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Confirm validation modal -->
  <ng-template #confirmValidModel let-modal>
    <div class="modal-shell duplicate-doc-modal confirm-valid-modal">
      <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Confirm Validation</h4>
        <button type="button" class="close" aria-label="Close" (click)="onConfirmValidCancel(modal)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-modal-body p-3">
        <p>
          This will mark the document as valid, indicating it has been reviewed and found satisfactory.
        </p>
      </div>
      <div class="form-modal-footer p-3">
        <div class="modal-actions d-flex justify-content-center gap-2">
          <button type="button" class="btn btn-primary btn-md px-3 py-1" (click)="onConfirmValidProceed()">Proceed</button>
          <button type="button" class="btn document-preview-cancel btn-md px-3 py-1" (click)="onConfirmValidCancel(modal)">Cancel</button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- Replace file modal -->
  <ng-template #replaceModel let-modal>
    <form (ngSubmit)="onReplaceSave()">
      <div class="upload-form-popup">
        <div class="form-modal-header p-4 d-flex justify-content-between">
          <h4 class="modal-title">Replace File</h4>
          <button type="button" class="close" aria-label="Close" (click)="closePopup()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="form-modal-body pl-4 pr-4 pt-4 pb-2">
          <div class="mb-3">
            <label class="col-form-label mb-2">Select Replacement File <span class="text-danger">*</span></label>
            <div class="uplaodfile-popup">
              <p-fileUpload #fileUpload mode="advanced" name="demo[]" [customUpload]="true" chooseLabel="Upload"
                chooseIcon="pi pi-upload" [dragDrop]="needDragAndDrop" [maxFileSize]="maxFileSize" [auto]="true"
                [accept]="allowedTypes"
                [invalidFileTypeMessageSummary]="''"
                [invalidFileTypeMessageDetail]="fileTypeNotSupportedMessage"
                [invalidFileSizeMessageSummary]="''"
                [invalidFileSizeMessageDetail]="fileSizeExceededMessage"
                (onError)="handleFileUploadError($event)" (uploadHandler)="onUpload($event, fileUpload)">
                <ng-template pTemplate="content" *ngIf="needDragAndDrop">
                  <div class="custom-upload-text text-center mt-2">
                    Drag & drop or
                    <a class="choose-link" (click)="fileUpload.choose()">choose a file</a>
                    to upload
                  </div>
                </ng-template>
              </p-fileUpload>
            </div>
            <div *ngIf="fileUploadError" class="text-danger small mt-20">
              {{ fileUploadError }}
            </div>
            
            <ng-container *ngIf="isShow">
              <div class="d-flex flex-column  file mt-20" *ngFor="let file of uploadedFiles">
                <p class="file__name">{{ file?.name }}</p>
                <div class="d-flex" *ngIf="showAction">
                  <p-button (click)="deleteAttachment(file)" pTooltip="Delete attachment" tooltipPosition="bottom"
                    aria-label="Delete attachment">
                    <em class="pi pi-trash"></em>
                  </p-button>
                  <p-button (click)="viewAttachment(file, false)" class="ml-2" pTooltip="View attachment" tooltipPosition="bottom"
                    aria-label="View attachment">
                    <em class="fa fa-eye"></em>
                  </p-button>
                  <p-button (click)="viewAttachment(file, true)" class="ml-2" pTooltip="Download attachment"
                    tooltipPosition="bottom" aria-label="Download attachment">
                    <em class="fa fa-download"></em>
                  </p-button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!isShow">
              <div class="no-file-uploaded mt-20">
                <i class="pi pi-file"></i>
                <span>No file uploaded</span>
              </div>
            </ng-container>
          </div>
          <div *ngIf="replaceUploadError" class="text-danger small mt-2">{{ replaceUploadError }}</div>
           <div class="mb-3 filedetails">
            <p class="filesformat">
              Supported formats: PDF, JPG, JPEG, PNG.
            </p>
            <p class="filesformat">
              Maximum size: 15 MB.
            </p>
          </div>
        </div>
        <div class="form-modal-footer p-3 d-flex">
          <button type="button" class="btn-cancel btn  btn-md  px-3 py-1" (click)="closePopup()">Cancel</button>
          <button type="button" class="btn btn-primary btn-md rounded ms-2" (click)="onReplaceSave()">Replace</button>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template #uploadModel let-modal>
    <form #uploadForm="ngForm" (ngSubmit)="onUploadSave()" novalidate>
      <div class="upload-form-popup">
      <div class="form-modal-header p-4 d-flex justify-content-between">
        <h4 class="modal-title">Upload Files</h4>
        <button type="button" class="close" aria-label="Close" (click)="onUploadCancelClick()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-modal-body pl-4 pr-4 pt-4 pb-2">
        <!-- <div class="mb-3 d-flex flex-column align-items-start"> -->
        <div class="mb-3">
          <label class="col-form-label mb-2">Select File <span class="text-danger">*</span></label>
          <div class="uplaodfile-popup">
            <p-fileUpload #fileUpload mode="advanced" name="demo[]" [customUpload]="true" chooseLabel="Upload"
              chooseIcon="pi pi-upload" [dragDrop]="needDragAndDrop" [maxFileSize]="maxFileSize" [auto]="true"
              [accept]="allowedTypes"
              [invalidFileTypeMessageSummary]="''"
              [invalidFileTypeMessageDetail]="fileTypeNotSupportedMessage"
              [invalidFileSizeMessageSummary]="''"
              [invalidFileSizeMessageDetail]="fileSizeExceededMessage"
              (onError)="handleFileUploadError($event)" (uploadHandler)="onUpload($event, fileUpload)">
              <ng-template pTemplate="content" *ngIf="needDragAndDrop">
                <div class="custom-upload-text text-center mt-2">
                  Drag & drop or
                  <a class="choose-link" (click)="fileUpload.choose()">choose a file</a>
                  to upload
                </div>
              </ng-template>
            </p-fileUpload>
          </div>
          <div *ngIf="fileUploadError" class="text-danger small mt-20">
            {{ fileUploadError }}
          </div>
          
          <ng-container *ngIf="isShow">
            <div class="d-flex flex-column  file mt-20" *ngFor="let file of uploadedFiles">
              <p class="file__name">{{ file?.name }}</p>
              <div class="d-flex" *ngIf="showAction">
                <p-button (click)="deleteAttachment(file)" pTooltip="Delete attachment" tooltipPosition="bottom"
                  aria-label="Delete attachment">
                  <em class="pi pi-trash"></em>
                </p-button>
                <p-button (click)="viewAttachment(file, false)" class="ml-2" pTooltip="View attachment" tooltipPosition="bottom"
                  aria-label="View attachment">
                  <em class="fa fa-eye"></em>
                </p-button>
                <p-button (click)="viewAttachment(file, true)" class="ml-2" pTooltip="Download attachment"
                  tooltipPosition="bottom" aria-label="Download attachment">
                  <em class="fa fa-download"></em>
                </p-button>
              </div>
            </div>
          </ng-container>
          
          <ng-container *ngIf="!isShow">
            <div class="no-file-uploaded mt-20">
              <i class="pi pi-file"></i>
              <span>No file uploaded</span>
            </div>
          </ng-container>
                  </div>
        <div *ngIf="oneFileIsRequired" class="text-danger small mt-20">
          {{ oneFileIsRequiredError }}
        </div>
        <div class="mb-3 filedetails">
          <p class="filesformat">
            Supported formats: PDF, JPG, JPEG, PNG.
          </p>
             <p class="filesformat">
            Maximum size: 15 MB.
          </p>
        </div>
        <!-- Show requirements for Name Change applications -->
        <div *ngIf="isNameChangeApplication()" class="alert alert-info mb-3">
          <strong>Name Change Application Requirements:</strong><br>
          You must upload documents for both categories:
          <ul class="mb-0 mt-2">
            <li><strong>Proof of Photo Identification</strong> (Driver's License, Passport, or State-Issued ID)</li>
            <li><strong>Proof of Legal Name Change</strong> (Court documents, Marriage Certificate, etc.)</li>
          </ul>
        </div>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="category" class="col-form-label">Category <span class="text-danger">*</span></label>
            <div class="dropdown-clear-wrapper mt-1">
              <select id="category" class="form-control" [(ngModel)]="uploadData.category" name="category" required (change)="onCategoryChange()"
                [style.color]="uploadData.category === '' ? '#757575' : '#010101'"
                [ngClass]="{'empty-select': uploadData.category === ''}"
                aria-label="Select document category">
                <option value="" disabled hidden [selected]="!uploadData.category" style="color: #757575 !important;">Select Category</option>
                <option *ngFor="let c of categories" [value]="c.key">{{ c.value }}</option>
              </select>
              <button
                *ngIf="uploadData.category && categories && categories.length > 1"
                type="button"
                class="clear-icon"
                tabindex="-1"
                (click)="uploadData.category = ''; onCategoryChange(); $event.stopPropagation()"
                aria-label="Clear selection">
                &#10006;
              </button>
            </div>
            <div *ngIf="categoryError" class="text-danger small mt-1">
              {{ categoryError }}
            </div>
            <div *ngIf="categories && categories.length === 1 && uploadData.category" class="text-success small mt-1">
              <i class="fas fa-check-circle me-1"></i>
              Required Category of Document
            </div>
          </div>
          <div class="col-md-6 mb-3" *ngIf="isDocumentTypeRequired()">
            <label for="docType" class="col-form-label">Type <span class="text-danger">*</span></label>
            <div class="dropdown-clear-wrapper mt-1">
              <select id="docType" class="form-control" [(ngModel)]="uploadData.docType" name="docType" required [disabled]="!uploadData.category"
                [style.color]="uploadData.docType === '' ? '#757575' : '#010101'"
                [ngClass]="{'empty-select': uploadData.docType === ''}" (change)="onDocTypeChange()"
                aria-label="Select document type">
                <option value="" hidden disabled selected style="color: #757575 !important;">
                  {{ uploadData.category ? 'Select Type' : 'Please select a category first' }}
                </option>
                <option *ngFor="let d of filteredDocumentTypes" [value]="d.key">{{ d.value }}</option>
              </select>
              <button
                *ngIf="uploadData.docType && uploadData.category"
                type="button"
                class="clear-icon"
                tabindex="-1"
                (click)="uploadData.docType = ''; $event.stopPropagation()"
                aria-label="Clear selection">
                &#10006;
              </button>
            </div>
            <div *ngIf="docTypeError" class="text-danger small mt-1">
              {{ docTypeError }}
            </div>
            <div *ngIf="duplicateDocTypeError" class="text-danger small mt-1">
              {{ duplicateDocTypeError }}
            </div>
            <div *ngIf="!uploadData.category" class="text-muted small mt-1">
              Document types will appear after selecting a category
            </div>
          </div>
          <!-- <div class="col-md-6 mb-3 mt-4 pt-1" *ngIf="!isDocumentTypeRequired() && uploadData.category && !(categories && categories.length === 1)">
            <div class="alert alert-info small mb-0">
              <i class="fas fa-info-circle me-2"></i>
              No document type selection required for this category.
            </div>
          </div> -->
        </div>
      </div>
      <div class="form-modal-footer p-3 d-flex">
        <button type="button" class="btn-cancel btn  btn-md  px-3 py-1" (click)="onUploadCancelClick()">Cancel</button>
        <button lang="en" class="btn btn-primary btn-md rounded ms-2" type="submit" name="data[submit]"
          [disabled]="!canSaveUpload()" ref="button">Save</button>
      </div>
      </div>
      
    </form>
  </ng-template>

  <!-- Row-upload modal: file only (no category/type) -->
  <ng-template #rowUploadModel let-modal>
    <form #rowUploadForm="ngForm" (ngSubmit)="onUploadSave()" novalidate>
      <div class="upload-form-popup">
        <div class="form-modal-header p-4 d-flex justify-content-between">
          <h4 class="modal-title">Upload File</h4>
          <button type="button" class="close" aria-label="Close" (click)="onUploadCancelClick()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="form-modal-body pl-4 pr-4 pt-4 pb-2">
          <div class="mb-3">
            <label class="col-form-label mb-2">Select File <span class="text-danger">*</span></label>
            <div class="uplaodfile-popup">
            <p-fileUpload #fileUpload mode="advanced" name="demo[]" [customUpload]="true" chooseLabel="Upload"
              chooseIcon="pi pi-upload" [dragDrop]="needDragAndDrop" [maxFileSize]="maxFileSize" [auto]="true"
              [accept]="allowedTypes"
              [invalidFileTypeMessageSummary]="''"
              [invalidFileTypeMessageDetail]="fileTypeNotSupportedMessage"
              [invalidFileSizeMessageSummary]="''"
              [invalidFileSizeMessageDetail]="fileSizeExceededMessage"
              (onError)="handleFileUploadError($event)" (uploadHandler)="onUpload($event, fileUpload)">
              <ng-template pTemplate="content" *ngIf="needDragAndDrop">
                <div class="custom-upload-text text-center mt-2">
                  Drag & drop or
                  <a class="choose-link" (click)="fileUpload.choose()">choose a file</a>
                  to upload
                </div>
              </ng-template>
            </p-fileUpload>
          </div>
          <div *ngIf="fileUploadError" class="text-danger small mt-20">
            {{ fileUploadError }}
          </div>
          
          <ng-container *ngIf="isShow">
            <div class="d-flex flex-column  file mt-20" *ngFor="let file of uploadedFiles">
              <p class="file__name">{{ file?.name }}</p>
              <div class="d-flex" *ngIf="showAction">
                <p-button (click)="deleteAttachment(file)" pTooltip="Delete attachment" tooltipPosition="bottom"
                  aria-label="Delete attachment">
                  <em class="pi pi-trash"></em>
                </p-button>
                <p-button (click)="viewAttachment(file, false)" class="ml-2" pTooltip="View attachment" tooltipPosition="bottom"
                  aria-label="View attachment">
                  <em class="fa fa-eye"></em>
                </p-button>
                <p-button (click)="viewAttachment(file, true)" class="ml-2" pTooltip="Download attachment"
                  tooltipPosition="bottom" aria-label="Download attachment">
                  <em class="fa fa-download"></em>
                </p-button>
              </div>
            </div>
          </ng-container>
          
          <ng-container *ngIf="!isShow">
            <div class="no-file-uploaded mt-20">
              <i class="pi pi-file"></i>
              <span>No file uploaded</span>
            </div>
          </ng-container>
          </div>
          <div *ngIf="oneFileIsRequired" class="text-danger small mt-20">
            {{ oneFileIsRequiredError }}
          </div>
          <div class="mb-3 filedetails">
            <p class="filesformat">
              Supported formats: PDF, JPG, JPEG, PNG.
            </p>
            <p class="filesformat">
              Maximum size: 15 MB.
            </p>
          </div>
        </div>
        <div class="form-modal-footer p-3 d-flex">
          <button type="button" class="btn-cancel btn  btn-md  px-3 py-1" (click)="onUploadCancelClick()">Cancel</button>
          <button lang="en" class="btn btn-primary btn-md rounded ms-2" type="submit" name="data[submit]"
            [disabled]="!canUploadDocuments()" ref="button">Save</button>
        </div>
      </div>
    </form>
  </ng-template>

  <!-- View document modal -->
  <ng-template #viewModel let-modal>
    <div class="document-preview-header">
      <h4 class="document-preview-title">Preview Document</h4>
    </div>
    <div class="form-modal-body document-preview-body">
      <ng-container *ngIf="previewDoc; else noPreview">
        <ng-container *ngIf="isImage(previewDoc); else nonImagePreview">
          <img class="document-preview-image" [src]="previewUrl" alt="Document preview">
        </ng-container>
        <ng-template #nonImagePreview>
          <ng-container *ngIf="isPdf(previewDoc); else unsupportedPreview">
            <iframe class="document-preview-frame" [src]="previewUrl" title="Document preview"></iframe>
          </ng-container>
          <ng-template #unsupportedPreview>
            <div class="p-3 text-center">
              <p class="mb-3">Preview is not available for this file type.</p>
              <button class="btn btn-primary btn-md" (click)="onDownload(previewDoc)">Download</button>
            </div>
          </ng-template>
        </ng-template>
      </ng-container>
      <ng-template #noPreview>
        <div class="p-3 text-muted text-center">No file available to preview.</div>
      </ng-template>
    </div>
    <div class="form-modal-footer p-3">
      <div class="justify-content-center modal-actions">
        <button type="button" class="btn document-preview-cancel px-3 py-1" (click)="closePopup()">Close</button>
      </div>
    </div>
  </ng-template>

  <!-- Duplicate document modal (applicant) -->
  <ng-template #duplicateApplicantModel let-modal>
    <div class="modal-shell duplicate-doc-modal">
      <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title mb-0">Duplicate Document Detected</h4>
        <button type="button" class="close" aria-label="Close" (click)="onDuplicateCancel(modal)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-modal-body p-3">
        <p>
          This document appears to already exist in the application. To avoid duplicates, please check your file or rename it before uploading.
        </p>
      </div>
      <div class="form-modal-footer p-3">
        <div class="modal-actions d-flex justify-content-end gap-2">
          <button type="button" class="btn document-preview-cancel btn-md px-3 py-1" (click)="onDuplicateCancel(modal)">Close</button>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Duplicate document modal (staff/admin) -->
  <ng-template #duplicateStaffModel let-modal>
    <div class="modal-shell duplicate-doc-modal">
      <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title mb-0">Duplicate Document Detected</h4>
        <button type="button" class="close" aria-label="Close" (click)="onDuplicateCancel(modal)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-modal-body p-3">
        <p>
          A document with the same Category and Filename already exists in this application. You can check your file or proceed with uploading.
        </p>
      </div>
      <div class="form-modal-footer p-3">
        <div class="modal-actions d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-primary btn-md px-3 py-1" (click)="onDuplicateProceed()">Proceed &amp; Upload</button>
          <button type="button" class="btn document-preview-cancel btn-md px-3 py-1" (click)="onDuplicateCancel(modal)">Cancel</button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #deleteModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
      <h4 class="form-modal-title mb-0">Delete Document</h4>
      <button type="button" class="close" aria-label="Close delete modal" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="form-modal-body p-3">
      <p class="delete-content">Are you sure you want to delete this document?<br>
This action cannot be undone.</p>
    </div>
    <div class="form-modal-footer p-3">
      <div class="justify-content-center modal-actions">
        <button class="btn document-preview-cancel btn-md px-3 py-1" (click)="modal.dismiss()">Cancel</button>
        <button class="btn btn-danger btn-md" (click)="onDeleteItem()">Delete</button>
      </div>
    </div>
  </ng-template>
  
  <!-- Confirm cancel upload modal -->
  <ng-template #confirmCancelModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
      <h4 class="form-modal-title mb-0">Cancel File Upload</h4>
    </div>
    <div class="form-modal-body p-3">
      <p>
        You have started uploading a file but have not yet saved it. Are you sure you want to cancel?
        Any unsaved changes will be lost.
      </p>
    </div>
    <div class="form-modal-footer p-3">
      <div class="justify-content-center modal-actions d-flex gap-2">
        <button type="button" class="btn document-preview-cancel btn-md px-3 py-1" (click)="onConfirmCancelNo()">No, Continue</button>
        <button type="button" class="btn btn-danger btn-md px-3 py-1" (click)="onConfirmCancelYes()">Yes, Cancel</button>
      </div>
    </div>
  </ng-template>
</div>
